<template>
  <div class="container ai_search_pos chat-container">
    <div class="card border ai-height">
      <b-row no-gutters>
        <b-col cols="3" class="history-menu sidebar" id="sidebar">
          <div class="sidebar-header">
            <span class="sidebar-title">Chats</span>
            <button class="add-chat-btn" title="New chat" @click="addNewChat">
              <fa :icon="['fas', 'plus']" />
            </button>
          </div>
          <div class="sidebarbox">
            <b-row v-for="(chat, index) in chats" no-gutters
              :class="['chat mx-auto my-1', (hoveredIndex === index || tooltipActiveIndex === index || activeChatIndex === index) ? 'chat-clicked' : '']"
              :key="index" @mouseover="hoveredIndex = index" @mouseleave="handleMouseLeave(index)"
              @click="changeChatLog(chat, index)">
              <b-col cols="10" class="pl-2 chat-title d-flex justify-content-between align-items-center">
                <span v-if="editIndex !== index" class="chat-title-text text-truncate">
                  {{ chat.title }}
                </span>
                <input v-else type="text" ref="editTitle" class="form-control form-control-sm" v-model="newTitle"
                  @blur="saveTitle(index)" @keyup.enter="saveTitle(index)" @click.stop style="max-width: 70%;" />
                <div class="timestamp">{{ chat.last_updated }}</div>
              </b-col>
              <b-col cols="1" class="ml-auto chat-options mr-1"
                v-if="(hoveredIndex === index || tooltipActiveIndex === index) && chat.chatSaved"
                :id="`chatSettings-${index}`">
              </b-col>
            </b-row>
          </div>
        </b-col>
        <b-col cols="9" id="mainContent" class="mainContent">
          <div class="messages-box" id="messages" v-if="chats[activeChatIndex]">
            <div v-for="(msg, index) in chats[activeChatIndex].messages" :key="index">
              <div class="chat-messages">
                <div class="message user " style="float: right;" v-if="msg.requestText && msg.requestTime">
                  {{ msg.requestText }}
                  <div class="timestamp">{{ msg.requestTime }}</div>
                </div>
              </div>
              <div class="chat-messages">
                <div class="message bot" v-if="msg.responseText && msg.responseTime">
                  {{ msg.responseText }}
                  <div class="timestamp">{{ msg.responseTime }}
                  </div>
                </div>
                <div class="message bot no-response" v-else>
                  <div class="typing-indicator" :data-text="msg.responseText">
                    {{ msg.responseText }}
                    <span class="dot ml-3"></span>
                    <span class="dot"></span>
                    <span class="dot"></span>
                  </div>
                </div>
              </div>
              <b-row class="col-md-3 feedbackIcons" v-if="msg.questionId >= 1 && msg.responseText && msg.responseTime">
                <b-col class="col-md-3 center ">
                  {{ msg.id }}
                  <fa :icon="['fas', 'thumbs-up']" :class="msg.feedback == true ? 'faFeedbackIcon' : 'faIcon'"
                    @click="saveFeedback(true, msg.questionId)" title="Like"></fa>
                </b-col>
                <b-col class="col-md-3 center">
                  <fa :icon="['fas', 'thumbs-down']" :class="msg.feedback == false ? 'faFeedbackIcon' : 'faIcon'"
                    @click="saveFeedback(false, msg.questionId)" title="Dislike">
                  </fa>
                </b-col>
              </b-row>
            </div>
          </div>
          <div class="bottom-container mb-2">
            <b-row class="col-md-5 mt-2">
              <b-col class="col-md-3 center bubble" @click="clearVectorLayers">
                <fa :icon="['fa', 'eraser']" class="widgetIcon" title="Remove Geometries" />
              </b-col>
              <b-col class="col-md-3 center bubble" v-show="loading" @click="getResponse('abort')">
                <fa :icon="['fa', 'stop']" class="widgetIcon fa-sm" title="Cancel Query" />
              </b-col>
            </b-row>
            <div class="input-group my-2" @submit.prevent="getResponse('execute')">
              <textarea style="border-radius: 10px" class="form-control ai-text p-2 mx-2 border textarea"
                placeholder="Ask anything..." id="textarea" v-model="userInput" @keyup.enter="getResponse('execute')" />
              <button v-if="!loader" class="btn bot_color mt-2 mr-2 btnstyle" type="submit"
                @click="getResponse('execute')">
                <fa :icon="['fas', 'arrow-up']"></fa>
              </button>
              <button v-if="loader" class="btn bot_color mt-2 mr-2 btnstyle" disabled>
                <fa :icon="['fas', 'sync']"></fa>
              </button>
            </div>
          </div>
        </b-col>
      </b-row>

    </div>
  </div>
</template>

<script>
import axios from 'axios'
import Feature from 'ol/Feature'
import Point from 'ol/geom/Point'
import Polygon from 'ol/geom/Polygon'
import { fromLonLat, transform } from 'ol/proj'
import VectorLayer from 'ol/layer/Vector.js';
import VectorSource from 'ol/source/Vector.js';
import Cluster from 'ol/source/Cluster.js';
import Overlay from 'ol/Overlay.js';
import Style from "ol/style/Style"
import CircleStyle from "ol/style/Circle"
import Fill from "ol/style/Fill";
import Stroke from "ol/style/Stroke"
import Text from "ol/style/Text"
import JSON5 from 'json5'
import { ref } from 'vue'
export default {
  data() {
    return {
      loader: false,
      userInput: '',
      showCol: null,
      questionId: 1,
      newChatMessages: [
        {
          questionId: 0,
          requestText: '',
          requestTime: null,
          responseText: 'Have a question about spatial data?',
          responseTime: new Date().toLocaleDateString() + " , " + new Date().toLocaleTimeString(navigator.language, { hour: '2-digit', minute: '2-digit' }),
          feedback: null
        }
      ],
      messages: [
        {
          questionId: 0,
          requestText: '',
          requestTime: null,
          responseText: 'Have a question about spatial data?',
          responseTime: new Date().toLocaleDateString() + " , " + new Date().toLocaleTimeString(navigator.language, { hour: '2-digit', minute: '2-digit' }),
          feedback: null
        }
      ],
      windowMinimized: false,
      chatMenuOpen: false,
      chats: [],
      hoveredIndex: null,
      tooltipActiveIndex: null,
      activeChatIndex: 0,
      editIndex: null,
      newTitleInput: '',
      activeChatobject: null,
      pointData: [],
      apiURL: null,
      resumedSession: false,
      oldSessionId: null,
      road_segment_geometry: null,
      clusterLayer: null,
      pointslayer: null,
      polygonLayer: null,
      user: null,
      loading: false,
      controller: null,    // AbortController instance,
      loaded: false,
      sessionId : ref(null)
    };
  },
  props: ['map'],
  methods: {
    renameHandler(index, currentTitle) {
      this.editIndex = index;
      this.newTitle = currentTitle

      this.$nextTick(() => {
        this.$refs.editTitle[0]?.focus();
      });
    },
    saveTitle(index) {
      if (this.newTitle.trim()) {
        this.chats[index].title = this.newTitle.trim();
      }
      this.editIndex = null;

      this.saveChat(this.chats[index])
      this.toggleTooltip(index)
    },
    async getUser() {
      if (sessionStorage.token) {
        await axios
          .get(process.env.API_LOCATION + '/api/auth', {
            headers: {
              'x-auth-token': sessionStorage.token
            }
          })
          .then(response => {
            let info = response.data
            let auth = info.authorization
            this.user = {
              email: info.email,
              id: info.id,
              inactive: info.inactive,
              name: info.name,
              org: info.org,
              role: auth.permissions,
              test: auth.testAccount == 'True',
              group: auth.group,
              extent: info.extent_id != null ? info.extent_id : null
            }
            this.isUshrUser = info.org == 1
            if (this.user.errors) {
              this.$router.push({ name: 'Login' })
            }
          })
          .catch(function (error) {
            console.log(error)
          })
      } else {
        this.$router.push({ name: 'Login' })
      }
    },
    getUserChats() {
      if (sessionStorage.token) {
        axios.get(process.env.API_LOCATION + '/api/spatial_intelligence/userMessagesLogs', {
          headers: {
            'x-auth-token': sessionStorage.token
          },
          params: {
            user_id: this.user.id
          }
        })
          .then(response => {
            const content = response.data
            if (content.errors) {
              console.log('userMessagesLogs API Call Error')
              console.log(content.errors)
            } else {
              content.forEach(chat => {
                this.chats.push({
                  id: chat.id,
                  title: chat.title,
                  last_updated: new Date(chat.last_updated).toLocaleDateString(),
                  messages: chat.messages,
                  chatSaved: true
                })
              })
            }
          })
          .catch(function (error) {
            console.log(error)
          })
      } else {
        console.log('No User Token')
      }
    },
    saveNewChat(chat) {
      if (sessionStorage.token) {
        let body = {
          user_id: this.user.id,
          title: chat.title,
          messages: chat.messages,
          user_name: this.user.name
        }
        axios.post(process.env.API_LOCATION + '/api/spatial_intelligence/createMessageLog', body,
          {
            headers: {
              'x-auth-token': sessionStorage.token
            },
          }
        ).then(response => {
          const content = response.data
          if (content.errors) {
            console.log(content.errors)
          } else {
            this.chats[this.activeChatIndex].id = content[0].id
            this.activeChatobject = content[0]
          }
        })
          .catch(function (error) {
            console.log(error)
          })
      } else {
        console.log('No User Token')
      }
    },
    toggleTooltip(index) {
      this.tooltipActiveIndex = this.tooltipActiveIndex === index ? null : index;
    },
    handleMouseLeave(index) {
      if (this.tooltipActiveIndex !== index) {
        this.hoveredIndex = null;
      }
    },
    changeChatLog(chat, index) {
      if (index != 0 && !this.chats[0].chatSaved) {
        this.chats.shift()
        index--;
      }
      this.activeChatIndex = index
      this.messages = []
      this.messages = chat.messages
      this.activeChatobject = null
      this.activeChatobject = chat
    },
    changeHeight() {
      this.windowMinimized = !this.windowMinimized
    },
    scrollToBottom() {
      this.$nextTick(() => {
        const messagesContainer = document.getElementById('messages')
        messagesContainer.scrollTop = messagesContainer.scrollHeight;
        const sidebarContainer = document.getElementById('sidebar')
        sidebarContainer.scrollTop = sidebarContainer.scrollHeight;
      })
    },
    downloadChat(chat) {
      const rows = [];
      // Header row
      rows.push(['AI Response', 'AI Response Time', `${this.user.name} Request`, `${this.user.name} Request Time`]);

      for (const message of chat.messages) {
        rows.push([
          message.questionId || '',
          message.responseText || '',
          message.responseTime || '',
          message.requestText || '',
          message.requestTime || '',
          message.feedback || null
        ]);
      }

      // Convert rows to CSV string
      const csvContent = rows.map(row =>
        row.map(val => `"${(val || '').toString().replace(/"/g, '""')}"`).join(',')
      ).join('\n');

      // Create a blob and trigger download
      const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
      const link = document.createElement('a');
      link.href = URL.createObjectURL(blob);
      link.setAttribute('download', `${chat.title}.csv`);
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    },
    async sendMessage(abort) {
      let value;
      let index = this.chats[this.activeChatIndex].messages.length - 1;
      //  CANCEL MODE
      if (abort !== "execute") {
        if (this.controller) {
          this.controller.abort();
        }
        return;
      }
      else {
        const input = this.userInput.trim();
        if (!input) return;
        this.loading = true;

        // Create controller only  
        this.controller = new AbortController();
        const signal = this.controller.signal;
        // Add user message
        this.chats[this.activeChatIndex].messages.push({
          questionId: 1,
          responseText: '',
          responseTime: null,
          requestText: input,
          requestTime: new Date().toLocaleDateString() + " , " + new Date().toLocaleTimeString(navigator.language, { hour: '2-digit', minute: '2-digit' }),
          feedback: null
        });

        index = this.chats[this.activeChatIndex].messages.length - 1;

        let responseIndex = 0;
        let items = ['Building query', 'Analyzing data', 'Formulating output']
        this.chats[this.activeChatIndex].messages[index].responseText = items[responseIndex]
        let responseInterval = setInterval(() => {
          responseIndex = responseIndex + 1
          this.chats[this.activeChatIndex].messages[index].responseText = items[responseIndex]
          if (responseIndex == items.length - 1) {
            clearInterval(responseInterval)
          }
        }, 5000)

        if (!this.chats[this.activeChatIndex].chatSaved) {
          this.saveNewChat(this.chats[this.activeChatIndex])
          this.chats[this.activeChatIndex].chatSaved = true;
        }

        this.userInput = ''
        let value
        const textarea = document.getElementById('textarea');
        // Disable the textarea
        textarea.disabled = true;
        this.loader = true
        this.scrollToBottom();
        let response
        try {
          response = await fetch(process.env.AI_ENDPOINT, {
            method: "POST",
            signal,
            headers: {
              "Content-Type": "application/json"
            },
            body: JSON.stringify({
              message: input,
              geometry: null,
              username: this.user.name,
              sessionId:this.sessionId
            })
          })

          // Check for a Bad Gateway error (HTTP status 502)
          if (response.status === 502) {
            value = "Bad Gateway error (502)"
            // Handle 502 specifically here
            return;
          }
          if (response.status === 500) {
            value = "Internal Server Error (500)"
            // Handle 502 specifically here
            return;
          }


          // Check for other non-OK status codes
          if (!response.ok) {
            value = `HTTP error! status: ${response.status}`
            console.error();
            // You can throw or handle accordingly
            return;
          }
          const data = await response.json();
          const rawdata = JSON5.parse(data.result)
          let subType = rawdata.results[0].sub_type
          switch (subType) {
            case "points":
            case "seg_ids":
              let datasize = JSON5.parse(rawdata.results[0].data).length
              this.initMap(rawdata.results[0].data, subType)
                .then(() => {
                  if (data.result === undefined) { value = data.error }
                  else if (data.result == 'error') { value = 'Data not found' }
                  else if (subType == ' insufficient context') { value = 'Insufficient context.' }
                  else { value = 'Showing ' + datasize + ' locations on map.'; }
                })
              break;
            case "text":
            case "":
              value = data.result == undefined ? data.error : rawdata.results[0].data.replace(/\[|\]|'/g, "");
              break;

          }
        }
        catch (error) {
          if (error.name === "AbortError") {
            value = "Request canceled by user.";
          } else if (error.message.includes("Failed to fetch")) {
            value = "Server timeout!";
          } else {
            value = "Error occurred.";
          }
        }
        finally {
          this.loading = false;
          this.controller = null;
          setTimeout(() => {
            this.loader = false;
            textarea.disabled = false;
            this.chats[this.activeChatIndex].messages[index].questionId = index
            this.chats[this.activeChatIndex].messages[index].responseText = `${value}`
            this.chats[this.activeChatIndex].messages[index].responseTime = new Date().toLocaleDateString() + " , " + new Date().toLocaleTimeString(navigator.language, { hour: '2-digit', minute: '2-digit' })
            this.scrollToBottom();
            this.saveChat(this.chats[this.activeChatIndex])
          }, 500);
          clearInterval(responseInterval);
        }
      }
    },
    saveChat(chat) {
      if (sessionStorage.token) {
        let body = {
          user_id: this.user.id,
          title: chat.title,
          messages: chat.messages,
          id: chat.id
        }
        axios.put(process.env.API_LOCATION + '/api/spatial_intelligence/updateMessageLog', body,
          {
            headers: {
              'x-auth-token': sessionStorage.token
            },
          }
        ).then(response => {
          const content = response.data
          if (content.errors) {
            console.log(content.errors)
          }
        })
          .catch(function (error) {
            console.log(error)
          })
      } else {
        console.log('No User Token')
      }
    },
    addNewChat() {
      this.chats.unshift({
        id: 0,
        title: 'New Chat',
        last_updated: new Date().toLocaleDateString(),
        messages: [
          {
            questionId: 0,
            requestText: '',
            requestTime: null,
            responseText: 'Have a question about spatial data?',
            responseTime: new Date().toLocaleDateString() + " , " + new Date().toLocaleTimeString(navigator.language, { hour: '2-digit', minute: '2-digit' }),
            feedback: null
          }
        ],
        chatSaved: false
      })
      this.generateSession()
    },
    saveFeedback(value, question_id) {
      if (sessionStorage.token) {
        axios.get(process.env.API_LOCATION + '/api/spatial_intelligence/saveFeedback', {
          headers: {
            'x-auth-token': sessionStorage.token
          },
          params: {
            chat_jsonb_id: question_id,
            chat_id: this.activeChatobject.id,
            user_id: this.user.id,
            feedback: value
          }
        })
          .then(response => {
            const content = response.data
            if (content.errors) {
              console.log('Save feedback API Call Error')
              console.log(content.errors)
            }
            else {
              this.$bvToast.toast('Thank you.', {
                autoHideDelay: 2000,
                variant: 'info',
                solid: true,
                title: 'Feedback Recived',
                toaster: 'b-toaster-top-center'
              })
              this.getFeedback();
            }
          })
          .catch(function (error) {
            console.log(error)
          })
      } else {
        console.log('No User Token')
      }
    },
    getFeedback() {
      if (sessionStorage.token) {
        axios.get(process.env.API_LOCATION + '/api/spatial_intelligence/getFeedback', {
          headers: {
            'x-auth-token': sessionStorage.token
          },
          params: {
            chat_id: this.activeChatobject.id,
            user_id: this.user.id
          }
        })
          .then(response => {
            const content = response.data
            if (content.errors) {
              console.log('Save feedback API Call Error')
              console.log(content.errors)
            }
            else {
              const chatIndex = this.chats.findIndex(chat => chat.id === this.activeChatobject.id);
              if (chatIndex !== -1) {
                this.chats[chatIndex].messages = content[0].messages;
              }
            }
          })
          .catch(function (error) {
            console.log(error)
          })
      } else {
        console.log('No User Token')
      }
    },
    async getRoadSegmentGeomtries(SegIds) {
      this.clearVectorLayers()
      if (sessionStorage.token) {
        axios.post(process.env.API_LOCATION + '/api/spatial_intelligence/getRoadSegmentGeomtries', {
          headers: {
            'x-auth-token': sessionStorage.token
          },
          params: {
            segment_ids: SegIds
          }
        })
          .then(response => {
            const content = response.data
            if (content.errors) {
              console.log('Save feedback API Call Error')
              console.log(content.errors)
            }
            else {
              try {
                this.clusterLayer = null
                this.polygonLayer = null
                const features = content.map(item => {
                  if (!item.st_asgeojson) {
                    console.warn('Missing st_asgeojson:', item);
                    return null;
                  }

                  let geojson;
                  try {
                    geojson = JSON.parse(item.st_asgeojson);
                  } catch (e) {
                    console.warn('Invalid JSON in st_asgeojson:', item.st_asgeojson);
                    return null;
                  }

                  if (!geojson.coordinates) {
                    console.warn('Skipping polygon, missing coordinates:', geojson);
                    return null;
                  }

                  // Remove elevation (3rd element) if present
                  const transformedCoords = geojson.coordinates.map(ring =>
                    ring.map(coord => fromLonLat(coord.slice(0, 2)))
                  );

                  //   return new Feature(new Polygon(transformedCoords));
                  // }).filter(f => f !== null);
                  // Create the feature with geometry
                  const feature = new Feature({
                    geometry: new Polygon(transformedCoords),
                    road_segment_id: item.road_segment_id,
                    coords: transformedCoords
                  });

                  // Optionally attach other properties if needed
                  // feature.set('name', item.name);

                  return feature;
                }).filter(f => f !== null);

                const vectorSource = new VectorSource({
                  features: features
                });
                // 3️ Compute centroids
                const centroidSource = new VectorSource();
                features.forEach((f) => {
                  const centroid = f.getGeometry().getInteriorPoint(); // point inside polygon
                  const centroidFeature = new Feature({
                    geometry: centroid,
                    original: f, // keep link to original polygon
                  });
                  centroidSource.addFeature(centroidFeature);
                });

                //  Cluster the centroids
                const clusterSource = new Cluster({
                  //   distance: 50, // cluster distance in pixels
                  source: centroidSource,
                });

                //  Cluster layer (circles with count)
                this.clusterLayer = new VectorLayer({
                  source: clusterSource,
                  name: 'clusterlayer',
                  style: (feature) => {
                    const size = feature.get('features').length;
                    return new Style({
                      image: new CircleStyle({
                        radius: Math.min(20, 10 + Math.log(size) * 4),
                        fill: new Fill({ color: 'rgba(255, 102, 0, 0.50)' }),
                        stroke: new Stroke({ color: '#114e86', width: 3 }),
                      }),
                      text: new Text({
                        text: size.toString() == 1 ? '' : size.toString(),
                        fill: new Fill({ color: '#000' }),
                        stroke: new Stroke({ color: '#fff', width: 4 }),
                        font: 'bold 16px Arial',
                      }),
                    });
                  },
                  zIndex: 9999,
                  maxZoom: 13
                });

                // Polygon layer (for visual reference)
                this.polygonLayer = new VectorLayer({
                  source: vectorSource,
                  name: 'polycluster',
                  style: new Style({
                    fill: new Fill({ color: 'rgba(255, 102, 0, 0.15)' }),
                    stroke: new Stroke({ color: '#114e86', width: 4 }),
                  }),
                  zIndex: 9999,
                  minZoom: 13
                });

                // Step 5: Add to map
                this.map.addLayer(this.polygonLayer);
                this.map.addLayer(this.clusterLayer);

                const extent = vectorSource.getExtent();
                this.map.getView().fit(extent, {
                  padding: [50, 50, 50, 500],
                  duration: 300,
                  maxZoom: 7 // Prevent over-zooming
                });

                // Create overlay for hover popup
                const container = document.createElement('div');
                container.className = 'ol-popup modern-popup';

                const overlay = new Overlay({ element: container });
                this.map.addOverlay(overlay);

                // Show road_id on hover
                this.map.on('pointermove', evt => {
                  let featureFound = false;
                  // Get current zoom level
                  const zoom = this.map.getView().getZoom();

                  // Only show popup if zoom is within a desired range
                  const minZoom = 13; // example minimum zoom
                  const maxZoom = 29; // example maximum zoom
                  if (zoom < minZoom || zoom > maxZoom) {
                    overlay.setPosition(undefined); // hide popup
                    return;
                  }
                  this.map.forEachFeatureAtPixel(evt.pixel, feature => {
                    featureFound = true
                    const roadId = feature.get('road_segment_id') || 'N/A'
                    container.innerHTML = `<b>Road ID:</b> ${roadId}`
                    overlay.setPosition(evt.coordinate)
                  });

                  if (!featureFound) {
                    overlay.setPosition(undefined); // hide popup
                  }
                });

              } catch (e) {
                console.log(e)
              }
            }
          })
          .catch(function (error) {
            console.log(error)
          })
      } else {
        this.$router.push({ name: 'Login' })
      }
    },
    initMap(data, sub_type) {
      return new Promise((resolve, reject) => {
        try {

          if (sub_type == "points") {
            this.clearVectorLayers()
            // // Add layer to map
            if (data != null || data != []) {
              try {
                this.pointslayer = null
                const parsed = JSON5.parse(data)
                const features = parsed.map(point => {
                  return new Feature({
                    type: 'geoMarker',
                    geometry: new Point(fromLonLat([point.lon, point.lat]))
                  });
                });
                // Step 2: Create a vector source with all features
                const vectorSource = new VectorSource({
                  features: features
                });

                // ---- Cluster source ----
                const clusterSource = new Cluster({
                  distance: 40, // pixel distance between points to cluster
                  source: vectorSource,
                });
                clusterSource.refresh();

                // ---- Style function for clusters ----
                const clusterStyle = feature => {
                  const size = feature.get('features').length;
                  return new Style({
                    image: new CircleStyle({
                      radius: Math.min(20, 10 + Math.log(size) * 4),
                      stroke: new Stroke({ color: '#114e86', width: 3 }),
                      fill: new Fill({ color: 'rgba(255, 0, 0, 0.50)' }),
                    }),
                    text: new Text({
                      text: size.toString() == 1 ? '' : size.toString(),
                      fill: new Fill({ color: '#000' }),
                      stroke: new Stroke({ color: '#fff', width: 4 }),
                      font: 'bold 16px Arial',
                    }),
                  });
                };

                // ---- Cluster layer ----
                this.pointslayer = new VectorLayer({
                  source: clusterSource,
                  name: 'points',
                  style: clusterStyle,
                  zIndex: 9999
                });

                // Step 5: Add to map
                this.map.addLayer(this.pointslayer);
                const extent = vectorSource.getExtent();
                this.map.getView().fit(extent, {
                  padding: [50, 50, 50, 500],
                  duration: 300,
                  maxZoom: 5 // Prevent over-zooming
                });

                // ---- Optional: dynamically change cluster distance based on zoom ----
                // this.map.getView().on('change:resolution', () => {
                //   const zoom = this.map.getView().getZoom();
                //   const newDistance = 80 - zoom * 5; // smaller clusters when zoomed in
                //   clusterSource.setDistance(Math.max(10, newDistance));
                // })
              }
              catch (e) {
                console.log(e)
              }
            }
          }
          else {
            try {
              this.getRoadSegmentGeomtries(data)
            }
            catch (e) {
              console.log(e)
            }
          }
          setTimeout(() => {
            resolve();
          }, 500);
        } catch (e) {
          return null
        }
      });
    },
    clearVectorLayers() {
      if (this.map && this.clusterLayer) {
        this.map.removeLayer(this.clusterLayer)
        this.clusterLayer = null
      }
      if (this.map && this.polygonLayer) {
        this.map.removeLayer(this.polygonLayer)
        this.polygonLayer = null
      }
      if (this.map && this.pointslayer) {
        this.map.removeLayer(this.pointslayer)
        this.pointslayer = null
      }
    },
    getResponse(action) {
      (async () => {
        try {
          this.sendMessage(action)
        } catch (e) {
        }
      })();

    },
    generateSession() {
      const id = crypto.randomUUID()
      sessionStorage.setItem('sessionId', id)
      this.sessionId= id
    }
  },
  async created() {
    if (!this.loaded) {
      await this.getUser()
      this.getUserChats()
      this.addNewChat()
      this.loaded = true;
    }
  },
  watch: {
    chats: {
      handler(newVal, oldVal) {
      },
      deep: true
    },
    user: function (newValue, oldValue) {
      this.user = newValue
    }
  }
}

</script>
<style >
.ai-height {
  height: 100vh;
}

/* ── Card shell ── */
.chat-container .card.ai-height {
  border: 1px solid rgba(6, 60, 109, 0.1) !important;
  border-radius: 16px;
  box-shadow: 0 12px 40px rgba(6, 60, 109, 0.14);
  overflow: hidden;
}

/* ── Sidebar header ── */
.sidebar-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0.85rem 0.9rem 0.7rem;
  border-bottom: 1px solid rgba(6, 60, 109, 0.08);
}

.sidebar-title {
  font-size: 0.72rem;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.09em;
  color: #063c6d;
}

.add-chat-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 28px;
  height: 28px;
  border: none;
  border-radius: 8px;
  background: linear-gradient(135deg, #1a5da8 0%, #063c6d 100%);
  color: #fff;
  font-size: 0.75rem;
  cursor: pointer;
  box-shadow: 0 2px 6px rgba(6, 60, 109, 0.25);
  transition: transform 0.15s ease, box-shadow 0.15s ease, opacity 0.15s ease;
}

.add-chat-btn:hover {
  transform: translateY(-1px);
  box-shadow: 0 4px 10px rgba(6, 60, 109, 0.35);
}

.bottom-container {
  position: fixed;
  bottom: 0;
  width: 26%;
  padding-top: 12px;
  background: linear-gradient(to top, #ffffff 55%, rgba(255, 255, 255, 0));
}

.sidebarbox {
  height: calc(100vh - 56px);
  overflow-y: auto;
  padding: 0.4rem 0.4rem 1rem;
}

.add-chat:hover {
  opacity: 0.7;
}

.chat-action:hover {
  background-color: rgb(2.6, 97.5, 151.45);
  border-radius: 5px;
  cursor: pointer;
}

.chat-action {
  padding: 5px 0px;
}

.chat-tooltip .arrow::before {
  border-top-color: rgb(2.6, 97.5, 151.45) !important;
  box-shadow: 0 0 1px rgba(0, 0, 0, 0.5) !important;
  visibility: hidden;
}

.chat-tooltip .tooltip-inner {
  background: #184877;
  /* box-shadow: 0 0 1px rgba(0, 0, 0, 0.5); */
  color: white;
  padding: 5px;
  border-radius: 5px;
  /* white-space: pre-line; */
  text-align: left;
  max-width: none !important;
  font-weight: normal;
  width: auto !important;
  white-space: nowrap;
  max-width: none !important;
}

.bubble {
  display: flex;
  align-items: center;
  justify-content: center;
  border: 1px solid #cdd9ec;
  background: #ffffff;
  border-radius: 12px;
  padding: 8px;
  margin-left: 4%;
  cursor: pointer;
  box-shadow: 0 1px 3px rgba(6, 60, 109, 0.06);
  transition: background-color 0.15s ease, box-shadow 0.15s ease, transform 0.15s ease;
}

.bubble:hover {
  background: #f2f7fd;
  box-shadow: 0 3px 8px rgba(6, 60, 109, 0.12);
  transform: translateY(-1px);
}

.chat-tooltip {
  opacity: 1.0 !important;
  width: auto !important;
  white-space: nowrap;
  max-width: none !important;
  position: absolute !important;
  will-change: transform !important;
  top: 0px !important;
  left: 0px !important;
  transform: translate3d(1052px, 46px, 0px) !important;
}

.chat {
  width: 95%;
  color: #33475b;
  cursor: pointer;
  min-height: 42px;
  border-radius: 10px;
  padding: 2px 4px;
  transition: background-color 0.15s ease, color 0.15s ease;
}

.chat-title {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  font-size: 0.9rem;
}

.chat-title-text {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  max-width: 70%;
  /* or use flex-grow if you'd rather */
}

.chat-options {
  display: flex;
  align-items: center;
  justify-content: center;
}

.chat-options:hover {
  opacity: 0.7;
  cursor: pointer;
}

.chat:hover {
  background-color: #e7eef7;
  color: #063c6d;
}

.chat-clicked {
  background: linear-gradient(135deg, #1a5da8 0%, #063c6d 100%);
  border-radius: 10px;
  color: #fff;
  box-shadow: 0 2px 8px rgba(6, 60, 109, 0.2);
}

.chat-clicked .timestamp {
  color: rgba(255, 255, 255, 0.7);
}

.gray-text {
  color: dimgray;
}

.history-menu {
  background-color: #f7fafd;
  border-right: 1px solid rgba(6, 60, 109, 0.08);
}

.open-color {
  color: aqua;
}

.chat-container {
  width: 35vw;
  border-radius: 10px;
  /* transition: width 0.5s !important; */
}

.messages-box {
  overflow-y: auto;
  transition: height 0.5s !important;
  padding-top: 5px;
  margin-bottom: 2%;
  position: relative;
  height: calc(100vh - 160px);
}

.chat-messages {
  flex: 1;
  padding: 0px 10px;
  overflow-y: auto;
}

.message {
  margin-bottom: 18px;
  max-width: 72%;
  padding: 12px 16px;
  border-radius: 18px;
  position: relative;
  line-height: 1.45;
  font-size: 0.92rem;
  word-break: break-word;
}

.message.user {
  background: linear-gradient(135deg, #1a5da8 0%, #063c6d 100%);
  color: #ffffff;
  align-self: flex-end;
  border-bottom-right-radius: 5px;
  box-shadow: 0 3px 10px rgba(6, 60, 109, 0.2);
}

.message.user .timestamp {
  color: rgba(255, 255, 255, 0.72);
}

.message.bot {
  background: #f1f4f8;
  color: #1f2d3d;
  border: 1px solid rgba(6, 60, 109, 0.06);
  align-self: flex-start;
  border-bottom-left-radius: 5px;
  max-width: 72%;
  width: auto !important;
  box-shadow: 0 1px 4px rgba(6, 60, 109, 0.05);
}

.message.bot.no-response {
  max-width: 60%;
}

.timestamp {
  font-size: 10px;
  color: #999;
  margin-top: 4px;
  text-align: right;
}

.chat-input {
  display: flex;
  padding: 10px 16px;
  border-top: 1px solid #ddd;
  background: #fff;
}

.chat-input input {
  flex: 1;
  padding: 10px 14px;
  border: 1px solid #ccc;
  border-radius: 20px;
  outline: none;
}

.chat-input button {
  background: #4a90e2;
  color: white;
  border: none;
  padding: 10px 16px;
  margin-left: 8px;
  border-radius: 20px;
  cursor: pointer;
  transition: background 0.3s;
}

.chat-input button:hover {
  background: #3b78c4;
}

.ai-text {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  text-align: left;
  min-height: 50px;
  max-height: 75px;
  height: auto;
}

.border {
  border-radius: 10px 10px 10px 10px;
}

.bot_color {
  background: linear-gradient(135deg, #1a5da8 0%, #063c6d 100%);
  height: 100%;
  color: white;
}

.btnstyle {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  color: white;
  background: linear-gradient(135deg, #1a5da8 0%, #063c6d 100%);
  height: 42px;
  width: 42px;
  border: none;
  box-shadow: 0 3px 8px rgba(6, 60, 109, 0.28);
  transition: transform 0.15s ease, box-shadow 0.15s ease, opacity 0.15s ease;
}

.btnstyle:hover:not(:disabled) {
  color: white;
  transform: translateY(-1px);
  box-shadow: 0 5px 14px rgba(6, 60, 109, 0.38);
}

.btnstyle:disabled {
  opacity: 0.6;
}

/* TYPING ANIMATION */
.typing-indicator {
  position: relative;
  display: inline-block;
  color: black;
  /* solid text always visible */
  font-weight: 600;
  overflow: hidden;
}

/* subtle silver shimmer overlay */
/* .typing-indicator::after {
  content: attr(data-text);
  position: absolute;
  top: 0;
  left: 0;
  width: auto;
  color: black; */
/* background: linear-gradient(
    90deg,
    rgba(255, 255, 255, 0) 0%,
    rgba(255, 255, 255, 0.4) 45%,
    rgba(255, 255, 255, 0.7) 50%,
    rgba(255, 255, 255, 0.4) 55%,
    rgba(255, 255, 255, 0) 100%
  ); */
/* background: black; */
/* background-size: 200% 100%;
  -webkit-background-clip: text;
  background-clip: text; */
/* animation: waveBlink 3s linear infinite; */
/* pointer-events: none;
} */

/* LEFT → RIGHT movement, slower and softer */
/* @keyframes waveBlink {
  0% {
    background-position: 100% 0;
  }
  100% {
    background-position: -100% 0;
  }
} */

.typing-indicator .dot {
  width: 6px;
  height: 6px;
  border-radius: 50%;
  background-color: black;
  animation: blink 1.2s infinite;
}

.typing-indicator .dot:nth-child(2) {
  animation-delay: 0.2s;
}

.typing-indicator .dot:nth-child(3) {
  animation-delay: 0.4s;
}

.widgetIcon {
  color: #184877;
}

.widgetIcon:hover {
  color: rgb(255, 149, 0);
  transition: all 0.3s ease;
  /* Smooth transition for hover effect */
  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.1);
  /* Subtle shadow */
}

.faIcon {
  color: #184877;
  font-size: 0.80rem;
}

.faFeedbackIcon {
  color: #d17606;
  font-size: 0.80rem;
}

.faFeedbackIcon:hover {
  transform: scale(1.2);
}

.faIcon:hover {
  transform: scale(1.2);
  /* slightly enlarge on hover */
}

.textarea {
  width: 100%;
  min-height: 50px;
  max-height: 150px;
  resize: none;
  padding: 12px 16px;
  border-radius: 14px !important;
  border: 1px solid #d3dfec !important;
  background-color: #fbfcfe;
  font-size: 0.95rem;
  color: #063c6d;
  outline: none;
  box-shadow: 0 1px 3px rgba(6, 60, 109, 0.05);
  transition: border-color 0.2s ease, box-shadow 0.2s ease, background-color 0.2s ease;
}

.textarea::placeholder {
  color: #9fb3c8;
}

.textarea:focus {
  border-color: #1a5da8 !important;
  background-color: #ffffff;
  box-shadow: 0 0 0 3px rgba(26, 93, 168, 0.12);
}

.sidebar {
  transition: width 0.4s ease;
  overflow: hidden;
}

.sidebar.collapsed {
  width: 0 !important;
  padding: 0 !important;
}

.content {
  transition: width 0.4s ease;
}

.feedbackIcons {
  margin-top: -20px;
}

.mainContent {
  padding-top: 2%
}

.modern-popup {
  background-color: #ffffff;
  /* clean white background */
  padding: 10px 15px;
  /* more comfortable spacing */
  border-radius: 8px;
  /* rounded corners */
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  /* subtle shadow */
  border: none;
  /* no harsh border */
  font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
  font-size: 14px;
  color: #333333;
  /* dark gray text */
  pointer-events: auto;
  /* allow clicks inside popup */
  max-width: 250px;
  /* optional: limit width */
}

.modern-popup b {
  color: #1a73e8;
  /* highlight labels in blue */
}

@keyframes blink {

  0%,
  80%,
  100% {
    opacity: 0.2;
  }

  40% {
    opacity: 1;
  }
}
</style>

<style scoped>
.hr {
  margin-top: 1px;
  margin-bottom: 4px;
  background-color: #80909f !important;
}

ScrollStyle {
  max-height: 1055px;
  overflow-y: scroll;
}

/* Thin, seamless scrollbar */
::-webkit-scrollbar {
  width: 8px;
  height: 8px;
}

::-webkit-scrollbar-track {
  background: transparent;
}

::-webkit-scrollbar-thumb {
  background-color: rgba(100, 100, 100, 0.4);
  border-radius: 20px;
  transition: background-color 0.3s ease;
}

::-webkit-scrollbar-thumb:hover {
  background-color: rgba(100, 100, 100, 0.7);
}

/* Remove arrow buttons */
::-webkit-scrollbar-button {
  display: none;
  height: 0;
  width: 0;
}

#AI-content {
  scrollbar-width: thin !important;
  scrollbar-color: rgba(100, 100, 100, 0.4) transparent;
}

</style>
